<div class="wrapper__headerComponent container my-1">
  <div class="row">
    <div class="d-flex flex-row align-items-start">
      <img
        src="../../../../assets/img/file-alt.svg"
        alt="logo"
        class="img-ico-form" />
      <h2 class="mb-0">{{ configurarText['administar-cuenta'] }}</h2>
    </div>
  </div>
</div>
<div class="container mb-3">
  <div
    class="d-flex flex-column flex-md-row align-items-start justify-content-start mt-5 gap-3 card__profile">
    <div
      class="border__form rounded px-3 py-4 flex-shrink-0 card__profile__left">
      <div class="d-flex flex-column align-items-center gap-3">
        <img
          src="https://ui-avatars.com/api/?background=b5c7e9&name={{
            getInicialesNombreUsuario()
          }}&size=200&rounded=true&color=0943b5"
          alt="" />
        <div class="d-flex flex-column gap-2">
          <h5 *ngIf="getNombreUsuario()">{{ getNombreUsuario() }}</h5>
          <div class="d-flex flex-row align-items-center gap-2">
            <span class="govco-svg govco-address-card"></span>
            <p class="mb-0 form-label text3-tipografia-govco mb-0">
              {{ getNumeroDocumento() }}
            </p>
          </div>
          <div class="d-flex flex-row align-items-center gap-2">
            <span class="govco-svg govco-folder-user"></span>
            <p class="mb-0 form-label text3-tipografia-govco mb-0">
              {{ getTipoUsuario() }}
            </p>
          </div>
          <div class="d-flex flex-row align-items-center gap-2">
            <span class="govco-svg govco-envelope"></span>
            <p class="mb-0 form-label text3-tipografia-govco mb-0">
              {{ getEmail() }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="border__form rounded px-3 py-4 flex-grow-1">
        <!-- SECCIÓN NUEVA -->
        <div class="alert alert-primary" role="alert" *ngIf="moreUsuarios">
          <div class="row">
            <div class="col-12 mb-2">
              <h4 class="mb-0 fw-bold">{{ configurarText['eres-abogado'] }}</h4>
            </div>
            <div class="col-12 mb-3">
              <p class="text-muted mb-0">{{ configurarText['si-soy-abogado'] }}</p>
            </div>
            <div class="col-12">
              <div class="d-flex flex-row gap-2">
                <button
                  type="button"
                  class="btn-govco outline-btn-govco hvr-shrink"
                  aria-label="Ignorar"
                >
                  {{ configurarText['ignorar'] }}
                </button>
                <button
                  type="button"
                  class="btn-govco fill-btn-govco hvr-shrink"
                  (click)="abrirModalAbogado()"
                  aria-label="Crear cuenta de abogado"
                >
                  {{ configurarText['crear-cuenta'] }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <!--  FIN SECCIÓN NUEVA -->
      <div class="d-flex flex-column align-items-start gap-3">
        <h4>{{ configurarText['datos-contacto'] }}</h4>
        <form [formGroup]="preferenciasForm">
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="form-group required form-label">
                <div class="d-flex flex-row align-items-center">
                  <label
                    for="primerNombre"
                    class="form-label text3-tipografia-govco mb-0"
                    >{{ comunText['primer-nombre'] }}</label
                  >
                  <span class="text-danger">*</span>
                </div>
                <input
                  class="form-control"
                  formControlName="primerNombre"
                  type="tel"
                  placeholder="{{ comunText['primer-nombre'] }}"
                  [ngClass]="{
                    'is-invalid': validateField(
                      preferenciasForm,
                      'primerNombre'
                    ),
                  }"
                  id="primerNombre"
                  (blur)="transformToUppercase('primerNombre')" />
                <div
                  class="invalid-feedback"
                  *ngIf="preferenciasForm.get('primerNombre')?.value">
                  {{
                    preferenciasForm.get('primerNombre')?.errors?.['minlength']
                      ? comunText['nombre-minlength']
                      : comunText['nombre-pattern']
                  }}
                </div>
                <div
                  class="invalid-feedback"
                  *ngIf="preferenciasForm.get('primerNombre')?.value">
                  {{
                    preferenciasForm.get('primerNombre')?.errors?.['maxlength']
                      ? configurarText['primer-nombre-maxlength']
                      : comunText['nombre-pattern']
                  }}
                </div>
                <div
                  *ngIf="
                    preferenciasForm.get('primerNombre')?.errors?.['required']
                  "
                  class="invalid-feedback">
                  {{ configurarText['primer-nombre-required'] }}
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group required form-label">
                <div class="d-flex flex-row align-items-center">
                  <label
                    for="segundoNombre"
                    class="form-label text3-tipografia-govco mb-0"
                    >{{ comunText['segundo-nombre'] }}</label
                  >
                </div>
                <input
                  class="form-control"
                  formControlName="segundoNombre"
                  type="tel"
                  placeholder="{{ comunText['segundo-nombre'] }}"
                  [ngClass]="{
                    'is-invalid': validateField(
                      preferenciasForm,
                      'segundoNombre'
                    ),
                  }"
                  id="segundoNombre"
                  (blur)="transformToUppercase('segundoNombre')" />
                <div
                  class="invalid-feedback"
                  *ngIf="preferenciasForm.get('segundoNombre')?.value">
                  {{
                    preferenciasForm.get('segundoNombre')?.errors?.['minlength']
                      ? comunText['nombre-minlength']
                      : comunText['nombre-pattern']
                  }}
                </div>
                <div
                  class="invalid-feedback"
                  *ngIf="preferenciasForm.get('segundoNombre')?.value">
                  {{
                    preferenciasForm.get('segundoNombre')?.errors?.['maxlength']
                      ? configurarText['segundo-nombre-maxlength']
                      : comunText['nombre-pattern']
                  }}
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group required form-label">
                <div class="d-flex flex-row align-items-center">
                  <label
                    for="primerApellido"
                    class="form-label text3-tipografia-govco mb-0"
                    >{{ comunText['primer-apellido'] }}</label
                  >
                  <span class="text-danger">*</span>
                </div>
                <input
                  class="form-control"
                  formControlName="primerApellido"
                  type="tel"
                  placeholder="{{ comunText['primer-apellido'] }}"
                  [ngClass]="{
                    'is-invalid': validateField(
                      preferenciasForm,
                      'primerApellido'
                    ),
                  }"
                  id="primerApellido"
                  (blur)="transformToUppercase('primerApellido')" />
                <div
                  class="invalid-feedback"
                  *ngIf="preferenciasForm.get('primerApellido')?.value">
                  {{
                    preferenciasForm.get('primerApellido')?.errors?.[
                      'minlength'
                    ]
                      ? comunText['apellido-minlength']
                      : comunText['nombre-pattern']
                  }}
                </div>
                <div
                  class="invalid-feedback"
                  *ngIf="preferenciasForm.get('primerApellido')?.value">
                  {{
                    preferenciasForm.get('primerApellido')?.errors?.[
                      'maxlength'
                    ]
                      ? configurarText['primer-apellido-maxlength']
                      : comunText['nombre-pattern']
                  }}
                </div>
                <div
                  *ngIf="
                    preferenciasForm.get('primerApellido')?.errors?.['required']
                  "
                  class="invalid-feedback">
                  {{ configurarText['primer-apellido-required'] }}
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group required form-label">
                <div class="d-flex flex-row align-items-center">
                  <label
                    for="segundoApellido"
                    class="form-label text3-tipografia-govco mb-0"
                    >{{ comunText['segundo-apellido'] }}</label
                  >
                </div>
                <input
                  class="form-control"
                  formControlName="segundoApellido"
                  type="tel"
                  placeholder="{{ comunText['segundo-apellido'] }}"
                  [ngClass]="{
                    'is-invalid': validateField(
                      preferenciasForm,
                      'segundoApellido'
                    ),
                  }"
                  id="segundoApellido"
                  (blur)="transformToUppercase('segundoApellido')" />
                <div
                  class="invalid-feedback"
                  *ngIf="preferenciasForm.get('segundoApellido')?.value">
                  {{
                    preferenciasForm.get('segundoApellido')?.errors?.[
                      'minlength'
                    ]
                      ? comunText['apellido-minlength']
                      : comunText['nombre-pattern']
                  }}
                </div>
                <div
                  class="invalid-feedback"
                  *ngIf="preferenciasForm.get('segundoApellido')?.value">
                  {{
                    preferenciasForm.get('segundoApellido')?.errors?.[
                      'maxlength'
                    ]
                      ? configurarText['segundo-apellido-maxlength']
                      : comunText['nombre-pattern']
                  }}
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group">
                <div class="d-flex flex-row align-items-center">
                  <label
                    for="fechaNacimiento"
                    class="form-label text3-tipografia-govco mb-0"
                  >{{"registry.fecha_nacimiento"| translate}}</label
                  >
                  <span class="text-danger">*</span>
                </div>
                <input
                  type="date"
                  class="form-control text3-tipografia-govco mb-0"
                  id="fechaNacimiento"
                  formControlName="fechaNacimiento"
                  placeholder="Fecha de nacimiento"
                  (input)="validarAnio($event)"
                  [ngClass]="{
                  'is-valid':
                    preferenciasForm.get('fechaNacimiento')?.valid &&
                    preferenciasForm.get('fechaNacimiento')?.touched,
                  'is-invalid':
                    preferenciasForm.get('fechaNacimiento')?.invalid &&
                    preferenciasForm.get('fechaNacimiento')?.touched,
                }" />
                <div
                  *ngIf="
                  preferenciasForm.get('fechaNacimiento')?.invalid &&
                  (preferenciasForm.get('fechaNacimiento')?.dirty ||
                    preferenciasForm.get('fechaNacimiento')?.touched)
                ">
                <span
                  *ngIf="
                    preferenciasForm.get('fechaNacimiento')?.errors?.[
                      'required'
                    ]
                  "
                  class="text-danger">
                  {{"registry.fecha_nacimiento_required"| translate}}
                </span>
                  <span
                    *ngIf="
                    preferenciasForm.get('fechaNacimiento')?.errors?.[
                      'edadRequerida'
                    ]
                  "
                    class="text-danger">
                  {{"registry.min_age"| translate}}
                </span>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group">
                <div class="d-flex flex-row align-items-center">
                  <label
                    for="nacionalidad"
                    class="form-label text3-tipografia-govco mb-0">
                    {{"datos-adicionales.nacionalidad"| translate}}
                  </label>
                </div>
                <select
                  formControlName="nacionalidad"
                  class="form-select ms-1"
                  type="text"
                  id="nacionalidad">
                  <option value disabled>{{"registry.seleccione_opcion"| translate}}</option>
                  <option *ngFor="let item of paises" [value]="item.Id">
                    {{ item.Nombre }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="form-group">
                <div class="d-flex flex-row align-items-center">
                  <label
                    for="pais"
                    class="form-label text3-tipografia-govco mb-0">
                    {{"comun-label.country"| translate}}
                  </label>
                  <span class="text-danger">*</span>
                </div>
                <select
                  formControlName="pais"
                  class="form-select ms-1"
                  type="text"
                  id="pais"
                  (change)="obtenerDepartamentos($event)"
                  [ngClass]="{
                    'is-invalid':
                      preferenciasForm.get('pais')?.invalid &&
                      preferenciasForm.get('pais')?.touched,
                  }">
                  <option value disabled>{{"registry.seleccione_opcion"| translate}}</option>
                  <option *ngFor="let item of paises" [value]="item.Id">
                    {{ item.Nombre }}
                  </option>
                </select>
                <div
                *ngIf="
                  preferenciasForm.get('pais')?.invalid &&
                  (preferenciasForm.get('pais')?.dirty ||
                    preferenciasForm.get('pais')?.touched)
                ">
                <span
                  *ngIf="
                    preferenciasForm.get('pais')?.errors?.['required']
                  "
                  class="text-danger">
                  {{"comun-label.country-required"| translate}}
                </span>
                </div>
              </div>
            </div>
            <div  class="col-12 col-md-6" *ngIf="esColombia">
              <div class="form-group">
                <div class="d-flex flex-row align-items-center">
                  <label
                    for="departamento"
                    class="form-label text3-tipografia-govco mb-0">
                    {{"datos-adicionales.departamento"| translate}}
                  </label>
                  <span class="text-danger">*</span>
                </div>
                <select
                  formControlName="departamento"
                  class="form-select ms-1"
                  type="text"
                  id="departamento"
                  (change)="obtenerMunicipios($event)"
                  [ngClass]="{
                    'is-invalid':
                      preferenciasForm.get('departamento')?.invalid &&
                      preferenciasForm.get('departamento')?.touched,
                  }">
                  <option value disabled>{{"registry.seleccione_opcion"| translate}}</option>
                  <option *ngFor="let item of departamentos" [value]="item.Id">
                    {{ item.Nombre }}
                  </option>
                </select>
                <div
                *ngIf="
                  preferenciasForm.get('departamento')?.invalid &&
                  (preferenciasForm.get('departamento')?.dirty ||
                    preferenciasForm.get('departamento')?.touched)
                ">
                <span
                  *ngIf="
                    preferenciasForm.get('departamento')?.errors?.['required']
                  "
                  class="text-danger">
                  {{"comun-label.departament-required"| translate}}
                </span>
                </div>
              </div>
            </div>
            <div  class="col-12 col-md-6" *ngIf="esColombia">
              <div class="form-group">
                <div class="d-flex flex-row align-items-center">
                  <label
                    for="municipio"
                    class="form-label text3-tipografia-govco mb-0">
                    {{"datos-adicionales.municipio"| translate}}
                  </label>
                  <span class="text-danger">*</span>
                </div>
                <select
                  formControlName="municipio"
                  class="form-select ms-1"
                  type="text"
                  id="municipio"
                  [ngClass]="{
                    'is-invalid':
                      preferenciasForm.get('municipio')?.invalid &&
                      preferenciasForm.get('municipio')?.touched,
                  }">
                  <option value disabled>{{"registry.seleccione_opcion"| translate}}</option>
                  <option *ngFor="let item of municipios" [value]="item.Id">
                    {{ item.Nombre }}
                  </option>
                </select>
                <div
                  *ngIf="
                    preferenciasForm.get('municipio')?.invalid &&
                    (preferenciasForm.get('municipio')?.dirty ||
                      preferenciasForm.get('municipio')?.touched)
                  ">
                  <span
                    *ngIf="
                      preferenciasForm.get('municipio')?.errors?.['required']
                    "
                    class="text-danger">
                    {{"comun-label.municipality-required"| translate}}
                  </span>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6" *ngIf="!esColombia">
              <div class="form-group">
                <div class="d-flex flex-row align-items-center">
                  <label
                    for="otroDepartamento"
                    class="form-label text3-tipografia-govco mb-0">
                    {{"comun-label.departament"| translate}}
                  </label>
                  <span class="text-danger">*</span>
                </div>
                <input
                  type="text"
                  class="form-control"
                  id="otroDepartamento"
                  formControlName="otroDepartamento"
                  [ngClass]="{
                  'is-invalid':
                    preferenciasForm.get('otroDepartamento')?.invalid &&
                    preferenciasForm.get('otroDepartamento')?.touched,
                }"
                (blur)="transformToUppercase('otroDepartamento')"/>
                <div
                  *ngIf="
                  preferenciasForm.get('otroDepartamento')?.invalid &&
                  (preferenciasForm.get('otroDepartamento')?.dirty ||
                    preferenciasForm.get('otroDepartamento')?.touched)
                ">
                <span
                  *ngIf="preferenciasForm.get('otroDepartamento')?.errors?.['maxlength']"
                  class="text-danger">
                  {{"comun-label.department-maxlength"| translate}}
                </span>
                <span
                  *ngIf="preferenciasForm.get('otroDepartamento')?.errors?.['required']"
                  class="text-danger">
                  {{"comun-label.departament-required"| translate}}
                </span>
                <span
                    *ngIf="preferenciasForm.get('otroDepartamento')?.errors?.['pattern']"
                    class="text-danger">
                 {{"comun-label.department-pattern"| translate}}
                </span>
                </div>
              </div>
            </div>
            <div  class="col-12 col-md-6" *ngIf="!esColombia">
              <div class="form-group">
                <div class="d-flex flex-row align-items-center">
                  <label
                    for="otroMunicipio"
                    class="form-label text3-tipografia-govco mb-0">
                    {{"comun-label.municipality"| translate}}
                  </label>
                  <span class="text-danger">*</span>
                </div>
                <input
                  type="text"
                  class="form-control"
                  id="otroMunicipio"
                  formControlName="otroMunicipio"
                  [ngClass]="{
                  'is-invalid':
                    preferenciasForm.get('otroMunicipio')?.invalid &&
                    preferenciasForm.get('otroMunicipio')?.touched,
                }"
                (blur)="transformToUppercase('otroMunicipio')"/>
                <div
                  *ngIf="
                  preferenciasForm.get('otroMunicipio')?.invalid &&
                  (preferenciasForm.get('otroMunicipio')?.dirty ||
                    preferenciasForm.get('otroMunicipio')?.touched)
                ">
                <span
                  *ngIf="
                    preferenciasForm.get('otroMunicipio')?.errors?.['required']
                  "
                  class="text-danger">
                  {{"comun-label.municipality-required"| translate}}
                </span>
                <span
                  *ngIf="preferenciasForm.get('otroMunicipio')?.errors?.['maxlength']"
                  class="text-danger">
                  {{"comun-label.municipality-maxlength"| translate}}
                </span>
                  <span
                    *ngIf="preferenciasForm.get('otroMunicipio')?.errors?.['pattern']"
                    class="text-danger">
                  {{"comun-label.municipality-pattern"| translate}}
                </span>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group required form-label">
                <div class="d-flex flex-row align-items-center">
                  <label
                    for="direccion"
                    class="form-label text3-tipografia-govco mb-0">
                    {{ comunText['direccion'] }}
                  </label>
                  <span class="text-danger">*</span>
                </div>
                <input
                  type="text"
                  id="direccion"
                  class="form-control"
                  formControlName="direccion"
                  [ngClass]="{
                    'is-invalid': validateField(preferenciasForm, 'direccion'),
                  }"
                  placeholder="Dirección"
                  (blur)="transformToUppercase('direccion')" />
                <div
                  *ngIf="preferenciasForm.get('direccion')?.errors?.['required']"
                  class="invalid-feedback">
                  {{ configurarText['direccion-required'] }}
                </div>
                <div
                  class="invalid-feedback"
                  *ngIf="
                    preferenciasForm.get('direccion')?.errors?.['minlength']
                  ">
                  {{ configurarText['direccion-minlength'] }}
                </div>
                <div
                  class="invalid-feedback"
                  *ngIf="
                    preferenciasForm.get('direccion')?.errors?.['maxlength']
                  ">
                  {{ 'datos-adicionales.direccion-maxlength' | translate}}
                </div>
                <div
                  *ngIf="preferenciasForm.get('direccion')?.errors?.['pattern']"
                  class="invalid-feedback">
                  {{ comunText['direccion-notificacion-judicial-pattern'] }}
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group required form-label">
                <div class="d-flex flex-row align-items-center">
                  <label
                    for="telefono"
                    class="form-label text3-tipografia-govco mb-0"
                    >{{ configurarText['telefono'] }}</label
                  >
                  <span class="text-danger">*</span>
                </div>
                <input
                  class="form-control"
                  formControlName="telefono"
                  type="tel"
                  placeholder="Telefono"
                  [ngClass]="{
                    'is-invalid': validateField(preferenciasForm, 'telefono'),
                  }"
                  id="telefono" />
                <div
                  class="invalid-feedback"
                  *ngIf="
                    preferenciasForm.get('telefono')?.errors?.['minlength']
                  ">
                  {{ configurarText['telefono-minlength'] }}
                </div>
                <div
                  class="invalid-feedback"
                  *ngIf="
                    preferenciasForm.get('telefono')?.errors?.['maxlength']
                  ">
                  {{ configurarText['telefono-maxlength'] }}
                </div>
                <div
                  *ngIf="preferenciasForm.get('telefono')?.errors?.['required']"
                  class="invalid-feedback">
                  {{ configurarText['telefono-required'] }}
                </div>
                <div
                  *ngIf="preferenciasForm.get('telefono')?.errors?.['pattern']"
                  class="invalid-feedback">
                  {{ configurarText['telefono-pattern'] }}
                </div>
              </div>
            </div>
            <div
              class="d-flex flex-column flex-md-row justify-content-between mt-2 gap-2">
              <div class="">
                <div class="form-check mt-2">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value="true"
                    formControlName="notificaciones" />
                  <label
                    class="form-check-label form-label text3-tipografia-govco mb-0"
                    for="flexCheckDefault">
                    {{ configurarText['desea-recibir-notificaciones'] }}
                  </label>
                </div>
              </div>
              <button
                *ngIf="isPersona"
                type="button"
                class="btn-govco fill-add-govco hvr-shrink"
                (click)="abrirModalPersona()"
                [attr.aria-label]="configurarText['ver-datos']">
                <div class="d-flex flex-row align-items-center gap-2">
                  <span class="govco-svg govco-portrait" aria-hidden="true"></span>
                  <p class="mb-0">
                    {{ configurarText['ver-datos'] }}
                  </p>
                </div>
              </button>
              <button
                *ngIf="isAbogado"
                type="button"
                class="btn-govco fill-add-govco hvr-shrink"
                (click)="abrirModalAbogado()"
                [attr.aria-label]="configurarText['ver-datos']">
                <div class="d-flex flex-row align-items-center gap-2">
                  <span class="govco-svg govco-portrait" aria-hidden="true"></span>
                  <p class="mb-0">
                    {{ configurarText['ver-datos'] }}
                  </p>
                </div>
              </button>
            </div>
            <div
              class="d-flex flex-column flex-md-row justify-content-end my-2 gap-2 mt-2 mt-md-5">
              <button
                type="button"
                class="btn-govco outline-btn-govco hvr-shrink"
                (click)="enviarMensajeCambiarContrasena()"
                [attr.aria-label]="configurarText['cambiar-contrasenia']">
                {{ configurarText['cambiar-contrasenia'] }}
              </button>
              <button
                type="button"
                class="btn-govco fill-btn-govco hvr-shrink"
                (click)="guardar()"
                [disabled]="preferenciasForm.invalid"
                aria-label="Guardar cambios">
                {{ configurarText['guardar'] }}
              </button>
            </div>
            <div *ngIf="isPersona && openModalPersona">
              <app-modal-datos-adicionales [openConfigCuenta]="true"></app-modal-datos-adicionales>
            </div>
            <div *ngIf="openModalAbogado">
              <app-modal-datos-adicionales-abogado [openConfigCuenta]="true"></app-modal-datos-adicionales-abogado>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
